import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import BuildChildren from 'utils/BuildChildren';
import SearchButtonB from 'components/SearchButton/SearchButtonB';
import classes from './SiteNavBDesktopLevelB.module.scss';

const SiteNavBDesktopLevelB = forwardRef((props, ref) => {
  const {
    imageUrl,
    imageLinkHref,
    imageLinkTarget,
    imageAltText,
    contactHref,
    contactTarget,
    button = {},
    items = [],
    searchResultsLinkHref,
    siteId,
    itemsCount,
    cartUrl,
    levelBSelectedIndex,
    onNavItemClick,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classNames(classes.wrapper, { [classes.noNavItems]: items.length === 0 })}>
        <Link
          href={imageLinkHref}
          target={imageLinkTarget}
          className={classes.logo}
        >
          <img
            src={imageUrl}
            alt={imageAltText}
            width={240}
          />
        </Link>
        <div className={classes.navItemListContainer}>
          <div className={classes.navItemList} ref={ref}>
            {items.map((item, i) => {
              const {
                heading,
                isActive,
              } = item;
              const baseClass = isActive ? classes.navItemActive : classes.navItem;
              const expandedClass = i === levelBSelectedIndex ? classes.navItemExpanded : '';
              const suppressedClass = isActive
                && levelBSelectedIndex > -1
                && i !== levelBSelectedIndex
                ? classes.navItemActiveSuppressed : '';

              return (
                <button
                  key={i}
                  type='button'
                  className={classNames(baseClass, expandedClass, suppressedClass)}
                  onClick={() => onNavItemClick(i, item)}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: heading }}
                  />
                  <FontIcon icon='far fa-angle-down' className={classes.navItemIcon} />
                </button>
              );
            })}
          </div>
        </div>
        <div className={classes.rightNav}>
          {contactHref && (
            <Link
              href={contactHref}
              target={contactTarget}
              className={classes.icon}
            >
              <FontIcon icon='fas fa-phone' className={classes.iconPhone} />
            </Link>
          )}
          <Link
            href={cartUrl}
            className={classes.icon}
          >
            <FontIcon icon='fas fa-shopping-cart' className={classes.iconCart}>
              {itemsCount > 0 ? <span className={classes.badge}>{itemsCount}</span> : null}
            </FontIcon>
          </Link>
          <SearchButtonB
            siteSearch360SiteId={siteId}
            siteSearch360SiteResults={searchResultsLinkHref}
            searchQueryString='search'
          />
          {button.subType && BuildChildren(button)}
        </div>
      </div>
    </div>
  );
});

const TItem = PropTypes.shape({
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  isActive: PropTypes.bool,
});

SiteNavBDesktopLevelB.propTypes = {
  items: PropTypes.arrayOf(TItem),
  imageUrl: PropTypes.string,
  imageLinkHref: PropTypes.string,
  imageLinkTarget: PropTypes.string,
  imageAltText: PropTypes.string,
  contactHref: PropTypes.string,
  contactTarget: PropTypes.string,
  button: PropTypes.object,
  searchResultsLinkHref: PropTypes.string,
  siteId: PropTypes.string,
  itemsCount: PropTypes.number,
  cartUrl: PropTypes.string,
  levelBSelectedIndex: PropTypes.number,
  onNavItemClick: PropTypes.func,
};

export default SiteNavBDesktopLevelB;
